module.exports = __webpack_public_path__ + "static/media/card5_8.1e1b35c7.png";